import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "link-library-24", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round", stroke: "currentColor", strokeWidth: 1.5 },
        React.createElement("path", { d: "M5.756 13.272A3.501 3.501 0 017 6.5h5a3.5 3.5 0 010 7" }),
        React.createElement("path", { d: "M18.244 10.728A3.501 3.501 0 0117 17.5h-5a3.5 3.5 0 010-7" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
